export default "__VITE_ASSET__BZSLjxx$__"